import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Field, SearchItem, SearchResults } from "../common/common.model";
import { IServiceInterface } from "../common/feltside/feltside.component";


@Injectable({
  providedIn: "root"
})
export class DatabaserService implements IServiceInterface<Database> {

  private readonly basePath = "api/database/";
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject("BASE_URL") private baseHost: string) {
    this.baseUrl = baseHost + this.basePath;
  }


  search(beskrivelse: string, sortOrder: string, pageNumber: number, pageSize: number, types?: string[], hasSystem?: boolean): Observable<DatabaseSearchResult> {
    let searchParams = new HttpParams();

    if (beskrivelse) { searchParams = searchParams.append("beskrivelse", beskrivelse); }
    if (sortOrder) { searchParams = searchParams.append("sortOrder", sortOrder); }

    if (types && types.length > 0) {
      types.forEach(t => {
        searchParams = searchParams.append("types", t);
      });
    }

    if (hasSystem !== null && hasSystem !== undefined) {
      searchParams = searchParams.append("hasSystem", hasSystem.toString());
    }

    searchParams = searchParams.append("pageNumber", pageNumber.toString());
    searchParams = searchParams.append("pageSize", pageSize.toString());

    return this.http.get<DatabaseSearchResult>(this.baseUrl, { params: searchParams });
  }


  get(databaseId: number): Observable<Database> {
    return this.http.get<Database>(this.baseUrl + databaseId);
  }

  put(database: Database): Observable<Database> {
    return this.http.put<Database>(this.baseUrl + database.databaseId, database);
  }

  post(database: Database): Observable<Database> {
    return this.http.post<Database>(this.baseUrl, database);
  }

  getFields(databaseId: number): Observable<Field[]> {
    return this.http.get<Field[]>(this.baseUrl + databaseId + "/fields");
  }

  getCreateFields(id?: number): Observable<Field[]> {
    throw new Error("Method not implemented.");
  }

  getTypes(): Observable<string[]> {
    return this.http.get<string[]>(this.baseUrl + "types");
  }

}

export interface Database {
  databaseId: number;
  navn: string;
  type: string;
  systemCount: number;
}


export interface DatabaseSearchResult {
  pageNumber: number;
  numberOfHits: number;
  totalPages: number;
  items: Database[];
}
